import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettingsService } from '@core/services/app-settings/app-settings.service';
import { BaseDataServiceV2 } from '@core/services/base-data/base-data-v2.service';
import { ControllerRoute } from '@shared/models/enums/controller-route.enum';
import { ITrainingEventResponse } from '@training/models/interfaces/training-event-response.interface';
import { ITrainingEvent } from '@training/models/interfaces/training-event.interface';
import { ReservationDocument } from '@training/models/reservation/reservation-document.model';
import { TrainingEvent } from '@training/models/training/training-event.model';
import { map, Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrainingEventsDataService extends BaseDataServiceV2 {
  constructor(
    appSettingsService: AppSettingsService,
    private httpClient: HttpClient
  ) {
    super(appSettingsService);
    this.appendResource(ControllerRoute.TrainingEvent, { apiVersions: [1, 2] });
  }

  public getTrainingEvents(): Observable<ITrainingEventResponse> {
    return this.apiResourceUrlVersions$.pipe(
      switchMap((apiResourceUrlVersions) =>
        this.httpClient.get<ITrainingEventResponse>(
          apiResourceUrlVersions[2],
          this.httpOptions
        )
      )
    );
  }

  public getTrainingEvent(
    geminiReservationId: string
  ): Observable<TrainingEvent> {
    return this.apiResourceUrl$.pipe(
      switchMap((apiResourceUrl) =>
        this.httpClient.get<ITrainingEvent>(
          `${apiResourceUrl}/${geminiReservationId}`,
          this.httpOptions
        )
      ),
      map((response) => new TrainingEvent(response))
    );
  }

  public getReservationDocument(
    geminiReservationId: string,
    documentName: string
  ): Observable<ReservationDocument> {
    return this.apiResourceUrl$.pipe(
      switchMap((apiResourceUrl) =>
        this.httpClient.get<ReservationDocument>(
          `${apiResourceUrl}/${geminiReservationId}/reservationDocuments/${documentName}`,
          this.httpOptions
        )
      )
    );
  }

  public updatePinnedEvents(pinnedEvents: string[]): Observable<string[]> {
    return this.apiResourceUrlVersions$.pipe(
      switchMap((apiResourceUrlVersions) =>
        this.httpClient.post<string[]>(
          `${apiResourceUrlVersions[2]}/pinnedEvents`,
          pinnedEvents,
          this.httpOptions
        )
      )
    );
  }

  public setContactCardIsDisplayed(reservationId: string): Observable<boolean> {
    return this.apiResourceUrl$.pipe(
      switchMap((apiResourceUrl) =>
        this.httpClient.patch<boolean>(
          `${apiResourceUrl}/setContactCardIsDisplayed?geminiReservationId=${reservationId}&platform=web`,
          this.httpOptions
        )
      )
    );
  }
}
